import { Controller } from "@hotwired/stimulus"

// Copia dados do contrato para o bloco de local da remoção. Na maioria das
// vezes é o mesmo endereço e a mesma pessoa — digitar de novo é trabalho e
// fonte de erro.
//
// Duas fontes, nesta ordem:
//   1. seletores (selectorsValue): lê os campos do contrato que estão na MESMA
//      página (venda direta), pegando o que o vendedor acabou de digitar,
//      mesmo sem salvar;
//   2. valores (dataValue): o que veio do servidor (checkout, etapa da OS).
export default class extends Controller {
  static targets = ["field"]
  static values = { data: Object, selectors: Object }

  fill(event) {
    event.preventDefault()
    const group = event.params.group // "address" | "contact"
    const source = this.dataValue[group] || {}
    const selectors = this.selectorsValue[group] || {}

    this.fieldTargets
      .filter((field) => field.dataset.prefillGroup === group)
      .forEach((field) => {
        const key = field.dataset.prefillKey
        const value = this.readSelector(selectors[key]) || source[key] || ""
        if (value === "") return

        field.value = value
        // Máscaras e selects dependentes (cidade por UF) reagem a estes eventos.
        field.dispatchEvent(new Event("input", { bubbles: true }))
        field.dispatchEvent(new Event("change", { bubbles: true }))
      })
  }

  readSelector(selector) {
    if (!selector) return null
    const el = document.querySelector(selector)
    return el && el.value ? el.value : null
  }
}
